'use client'
import type { FieldValues, UseFormRegister } from 'react-hook-form'
import { useFormContext } from 'react-hook-form'
import React, { useEffect } from 'react'
// Supabase identity (2026-08-26): the Clerk shim this used reported everyone
// signed out, so form submissions lost their member attribution after the cutover.
import { useSupabaseAuth } from '@/context/supabaseContext'

export const LoggedInUser: React.FC<{
  register: UseFormRegister<FieldValues>
}> = ({ register }) => {
  const props = register('loggedInUser')
  const { setValue } = useFormContext()
  const { user } = useSupabaseAuth()

  useEffect(() => {
    if (user) {
      setValue(props.name, user.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  return <React.Fragment></React.Fragment>
}
